import script from "./CaskTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./CaskTabs.vue?vue&type=script&setup=true&lang=js"

import "./CaskTabs.vue?vue&type=style&index=0&id=ca4a122a&lang=scss"

const __exports__ = script;

export default __exports__
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTabs,QTab});
